
























































































import { liveStudentListApi } from "@/api/live";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() lessonId!: number;
  dialogVisible: boolean = false;
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  getList(params: any) {
    params.lesson_id = this.lessonId;
    liveStudentListApi(params).then((res: any) => {
      if (res.error_code === 0) {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = params.page;
      }
    });
  }
  showDialog() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    this.dialogVisible = true;
  }
  hideDialog() {
    this.dialogVisible = false;
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
